import React from "react";
import {Container, Table, Badge, Button, ProgressBar} from "react-bootstrap";
import {Link, router} from "@inertiajs/react";
import {usePage} from "@inertiajs/react";
import NoNewsletterBanner from "../../Components/Campaigns/NoNewsletterBanner.jsx";
import {CAMPAIGN_STATUS_LABELS, campaignStatusLabel} from "../../Components/Campaigns/campaignStatusLabels.js";

function formatDate(value) {
    if (!value) {
        return null;
    }
    // Backend liefert "YYYY-MM-DD" (Campaign::$casts) - für die Anzeige
    // in gewohntes deutsches Format (TT.MM.JJJJ) umwandeln.
    const parts = String(value).split("-");
    if (parts.length !== 3) {
        return value;
    }
    const [year, month, day] = parts;
    return `${day}.${month}.${year}`;
}

/**
 * Übersichtsseite der E-Mail-Kampagnen: Liste mit Status in Klartext,
 * Empfängerzahl, Sende-Fortschritt und Zeitraum. "Bearbeiten" führt in den
 * Anlage-/Bearbeitungs-Assistenten (Edit.jsx), der Name-Link direkt in die
 * Kampagnen-Ansicht mit Empfängerstatus (Recipients.jsx).
 */
export default function Index() {
    const {campaigns} = usePage().props;
    const rows = campaigns?.data ?? [];

    const handleDelete = (campaign) => {
        if (!window.confirm(`Kampagne "${campaign.name}" wirklich unwiderruflich löschen?`)) {
            return;
        }
        router.delete(`/campaigns/${campaign.id}`);
    };

    return (
        <Container fluid className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1>E-Mail-Kampagnen</h1>
                <div className="d-flex gap-2">
                    <Link href="/campaigns/signatures" className="btn btn-outline-secondary">
                        Signaturen
                    </Link>
                    <Link href="/campaigns/mailboxes" className="btn btn-outline-secondary">
                        Absender-Postfächer
                    </Link>
                    <Link href="/campaigns/create" className="btn btn-primary">
                        Neue Kampagne
                    </Link>
                </div>
            </div>
            <NoNewsletterBanner/>
            <Table striped bordered hover className="mt-3 align-middle">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Empfänger</th>
                    <th style={{minWidth: 220}}>Fortschritt</th>
                    <th>Zeitraum</th>
                    <th className="text-end">Aktionen</th>
                </tr>
                </thead>
                <tbody>
                {rows.length === 0 && (
                    <tr>
                        <td colSpan={6} className="text-center text-muted py-4">
                            Noch keine Kampagnen angelegt. Über „Neue Kampagne" starten.
                        </td>
                    </tr>
                )}
                {rows.map((campaign) => {
                    const variant = CAMPAIGN_STATUS_LABELS[campaign.status]?.variant ?? "light";
                    const total = campaign.recipients_count ?? 0;
                    const sent = campaign.recipients_sent_count ?? 0;
                    const percent = total > 0 ? Math.round((sent / total) * 100) : 0;
                    const start = formatDate(campaign.send_start_date);
                    const end = formatDate(campaign.send_end_date);

                    return (
                        <tr key={campaign.id}>
                            <td>
                                <Link href={`/campaigns/${campaign.id}/recipients`} className="fw-semibold">
                                    {campaign.name}
                                </Link>
                            </td>
                            <td>
                                <Badge bg={variant}>{campaignStatusLabel(campaign.status)}</Badge>
                            </td>
                            <td>
                                {sent} von {total}
                            </td>
                            <td>
                                {total > 0 ? (
                                    <ProgressBar now={percent} label={`${percent}%`} style={{minWidth: 160}}/>
                                ) : (
                                    <span className="text-muted">Noch keine Empfänger</span>
                                )}
                            </td>
                            <td>
                                {start || end ? `${start ?? "?"} – ${end ?? "?"}` : <span className="text-muted">Kein Zeitraum festgelegt</span>}
                            </td>
                            <td className="text-end">
                                <div className="d-flex gap-2 justify-content-end">
                                    <Link href={`/campaigns/${campaign.id}/recipients`} className="btn btn-sm btn-outline-primary">
                                        Öffnen
                                    </Link>
                                    <Link href={`/campaigns/${campaign.id}/edit`} className="btn btn-sm btn-outline-secondary">
                                        Bearbeiten
                                    </Link>
                                    <Button size="sm" variant="outline-danger" onClick={() => handleDelete(campaign)}>
                                        Löschen
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>
        </Container>
    );
}
